import { Progress, Space } from 'antd';
import { V2EnergyGetAreaEnergyStatisticsPostResponse } from '@maxtropy/device-customer-apis-v2';
import styles from './index.module.scss';
import { formatNumberWithUnit, keepPercentOrLine, keepPercentTwoUndfined, keepTwoOrLine } from '@/utils/utils';

type CardData = V2EnergyGetAreaEnergyStatisticsPostResponse['tableData'];

const TopCard = ({ data }: { data: CardData }) => {
  return (
    <div className={styles.topCard}>
      {data?.map((item, index) => (
        <div className={styles.cardItem} key={index}>
          <div className={styles.mediumName}>{item.mediumName}</div>
          <div className={styles.mediumInfo}>
            <div className={styles.infoItem}>
              <div>
                <div style={{ color: 'var(--mx-text-secondary-color)' }}>生产时段用量</div>
                <div>{formatNumberWithUnit(item.productionPeriodUsage, item.unit)}</div>
              </div>
              <Space size={8} className={styles.right}>
                <Progress
                  type="circle"
                  size={26}
                  percent={item?.productionPeriodPercent ? keepPercentTwoUndfined(item?.productionPeriodPercent) : 0}
                  trailColor="#4A90E233"
                  showInfo={false}
                  strokeColor="#5BFF60"
                />
                {keepPercentOrLine(item?.productionPeriodPercent) + '%'}
              </Space>
            </div>
            <div className={styles.infoItem}>
              <div>
                <div style={{ color: 'var(--mx-text-secondary-color)' }}>非生产时段用量</div>
                <div>{formatNumberWithUnit(item.nonProductionPeriodUsage, item.unit)}</div>
              </div>
              <Space size={8} className={styles.right}>
                <Progress
                  type="circle"
                  size={26}
                  percent={
                    item?.nonProductionPeriodPercent ? keepPercentTwoUndfined(item?.nonProductionPeriodPercent) : 0
                  }
                  trailColor="#4A90E233"
                  showInfo={false}
                  strokeColor="#5BFF60"
                />
                {keepPercentOrLine(item?.nonProductionPeriodPercent) + '%'}
              </Space>
            </div>
            <div className={styles.infoItem}>
              <div>
                <div style={{ color: 'var(--mx-text-secondary-color)' }}>生产时段时长</div>
                <div>{keepTwoOrLine(item.productionPeriodTime)}h</div>
              </div>
              <Space size={8} className={styles.right}>
                <Progress
                  type="circle"
                  size={26}
                  percent={
                    item?.productionPeriodTimePercent ? keepPercentTwoUndfined(item?.productionPeriodTimePercent) : 0
                  }
                  trailColor="#4A90E233"
                  showInfo={false}
                  strokeColor="#5BFF60"
                />
                {keepPercentOrLine(item?.productionPeriodTimePercent) + '%'}
              </Space>
            </div>
            <div className={styles.infoItem}>
              <div>
                <div style={{ color: 'var(--mx-text-secondary-color)' }}>非生产时段时长</div>
                <div>{keepTwoOrLine(item.nonProductionPeriodTime)}h</div>
              </div>
              <Space size={8} className={styles.right}>
                <Progress
                  type="circle"
                  size={26}
                  percent={
                    item?.nonProductionPeriodTimePercent
                      ? keepPercentTwoUndfined(item?.nonProductionPeriodTimePercent)
                      : 0
                  }
                  trailColor="#4A90E233"
                  showInfo={false}
                  strokeColor="#5BFF60"
                />
                {keepPercentOrLine(item?.nonProductionPeriodTimePercent) + '%'}
              </Space>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default TopCard;
